export default function getDateFormat(datetime: number): string {

  const date = new Date(datetime);

  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  return `${hours}:${minutes}`;
}

